import CSSFoundationEmails from 'cio/assets/static-styles/foundation-emails-2.2.1.min.extcss';

export const SECONDS_IN_DAY = 86400;

export const SECONDS_IN_HOUR = 3600;

export const FOUNDATION_LIQUID_TAG = '{% include_foundation_css %}';
// The href below will get replaced with a fingerprinted URL in production
// builds
export const FOUNDATION_CSS_LINK = `<link href="${CSSFoundationEmails}" rel="stylesheet">`;
